// extracted by mini-css-extract-plugin
export default {"CarNumber":"styles_CarNumber__9B1zT","number":"styles_number__sCa6K"};